var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2609 21.1428H22V9.01239C22 8.53214 21.6107 8.14282 21.1304 8.14282V8.14282C20.6502 8.14282 20.2609 8.53214 20.2609 9.01239V9.40089M20.2609 21.1428V9.40089M20.2609 21.1428H12.8261M3.73913 21.1428H2V9.01239C2 8.53214 2.38932 8.14282 2.86957 8.14282V8.14282C3.34981 8.14282 3.73913 8.53214 3.73913 9.01239V9.40089M3.73913 21.1428V9.40089M3.73913 21.1428H11.1739M3.73913 9.40089H11.1739M20.2609 9.40089H12.8261M11.1739 9.40089V21.1428M11.1739 9.40089H12.8261M11.1739 21.1428H12.8261M12.8261 9.40089V21.1428M9.52174 13.5944L8.28261 14.8525L9.52174 16.1106M14.4783 13.5944L15.7174 14.8525L14.4783 16.1106",
    stroke: "#BF9A6D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7144 7.28563V7.28563C11.4929 6.76658 12.5072 6.76658 13.2858 7.28563V7.28563",
    stroke: "#BF9A6D",
    strokeWidth: 0.857153,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85718 5.99998V5.99998C11.1761 5.20858 12.8239 5.20858 14.1429 5.99998V5.99998",
    stroke: "#BF9A6D",
    strokeWidth: 0.857153,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.71433V4.71433C10.8589 3.65205 13.1411 3.65205 15 4.71433V4.71433",
    stroke: "#BF9A6D",
    strokeWidth: 0.857153,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricGate);
export default __webpack_public_path__ + "static/media/electric_gate.e978e431f86b990233f371e0c5bbafaf.svg";
export { ForwardRef as ReactComponent };